import { Badge, Box, Button, Flex, Text } from "@chakra-ui/react";
import moment from 'moment';
import { useHistory } from "react-router-dom";
import { parent, SubTema } from "../../../types/pengetahuan";
import ModalPemateri from "./ModalPemateri";

interface Props {
    data: (SubTema | parent)[];
    type: string;
    total: number;
    hideButton?: boolean;
}


const ListTemaPengetahuan: React.FC<Props> = ({ data, total, type, hideButton }) => {
    const history = useHistory();
    const urlDetail = '/detail/pengetahuan';
    return (
        <>
            <Box className="bg-white p-5 rounded-lg mt-4">
                <Flex className="w-full" justify="space-between" alignItems="center">
                    <Flex>
                        <Text fontSize="lg" fontWeight="semibold" mr={2}>
                            {type === "UTAMA" ? "Sub Tema" : "Tema Utama"}
                        </Text>
                        {type === "UTAMA" &&
                            <Badge fontWeight="normal" variant='solid' bg="green.700" alignContent="center" px={2} borderRadius="md">
                                {total}
                            </Badge>
                        }
                    </Flex>
                    {type === "UTAMA" &&
                        <Text color="green" as='u'>
                            Lihat Semua
                        </Text>
                    }
                </Flex>
                {type === "UTAMA" &&
                    <Text fontSize="sm" mt="1">
                        Sub Tema yang Tersedia
                    </Text>
                }
                <Box maxH="230px" overflowY="auto" pr="2" mt="4">
                    {data?.length > 0 ? (
                        data?.map((item, index) => (
                            <Box key={item.id || index} className="w-full" borderWidth='1px' borderRadius='lg' p="3" mb="3">
                                <Flex gridGap="2">
                                    <Badge maxH="30px" px="3" fontSize="md" fontWeight="semibold" variant='subtle' colorScheme='green' alignContent="center" borderRadius="full">
                                        {index + 1}
                                    </Badge>
                                    <Box gridGap="2">
                                        <Text fontWeight="semibold" fontSize="md" noOfLines={1}>
                                            {item.title}
                                        </Text>
                                        <Text fontWeight="semibold" color="blue.500">
                                            {moment(item.jadwal_mulai).locale("en").format("DD MMMM YYYY - hh:mm a")}
                                        </Text>
                                    </Box>
                                </Flex>
                                {!hideButton && (
                                    <Flex gridGap="2">
                                        {type === "UTAMA" && "status_pengetahuan_peserta" in item && (
                                            <ModalPemateri
                                                id={item.id}
                                                disable={item.status_pengetahuan_peserta?.status_pengetahuan !== "menunggu"}
                                            />
                                        )}
                                        <Button
                                            bg="green.700"
                                            color="white"
                                            fontWeight="normal"
                                            mt="3"
                                            isFullWidth
                                            onClick={() => {
                                                history.push(`${urlDetail}/${item.id}`)
                                            }}
                                        >
                                            Lihat Selengkapnya
                                        </Button>
                                    </Flex>
                                )}
                            </Box>
                        ))
                    ) : (
                        <p className="text-center text-md mt-8">Tidak ada Sub Tema!</p>
                    )}
                </Box>
            </Box>
        </>
    );
};

export default ListTemaPengetahuan;